import { fun_PostAction, fun_Download } from "@/api/index";
import { fun_DownloadFile } from "@/utils/validate.js";
import { Loading } from "element-ui";
import PrintDialog from "../../components/PrintDialog/index.vue";
import OpenBidRecord from "../components/openBidRecord/index.vue";

// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 全局加载
      fullLoading: null,
      // 列表loading状态
      loading: false,
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
        regulators: null, // 招标监管部门
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
      ],
      // 温馨提示
      tipList: [
        /*{
          type: "text",
          text: "当状态为“招标人确认中”时，招标人请点击项目名称进入详情后进行操作。"
        }*/
      ],
      // 表格按钮
      btnList: [
        {
          name: "重定候选人",
          type: "success",
        },
        {
          name: "重新招标",
          type: "danger",
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          width: "300",
          isShow: true,
        },
        {
          label: "状态",
          slotName: "state",
        },
        {
          label: "发布状态",
          slotName: "publicState",
        },
        {
          label: "招标组织形式",
          prop: "tenderMethodFlag",
        },
        {
          label: "处理方式",
          slotName: "type",
        },
        {
          label: "放弃中标单位",
          prop: "corpName",
        },
        {
          label: "标段号",
          prop: "section",
        },
        {
          label: "招标投标监管部门",
          prop: "regulators",
          width: "300",
        }
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 勾选的数组
      multipleSelection: [],
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
    };
  },
  // 注册组件
  components: {},

  // 模板编译完成
  mounted() {
    // 如果用户标识是工作人员或者监管人员
    if (this.userFlag === "工作人员" || this.userFlag === "监管人员" || this.userFlag === "分包合同监管人员") {
      // 清空表头
      this.btnList = [];
    }
    // 获取一览
    this.fun_GetList();
  },

  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/winningCandidate/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },

    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author shuhua
     */
    fun_click(e) {
      switch (e) {
        case "重定候选人":
          this.fun_Edit("0");
          break;
        case "重新招标":
          this.fun_Edit("1");
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },
    /**
     * 修改的方法
     * @author shuhua
     */
    fun_Edit(flag) {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 状态
          var state = this.multipleSelection[0].state;
          // 甲方确认信息编号
          var tenderSignedId = this.multipleSelection[0].tenderSignedId;
          // 甲方确认状态
          var tenderSignedState = this.multipleSelection[0].tenderSignedState;
          // 放弃中标单位
          var basicInfoId = this.multipleSelection[0].basicInfoId;
          // 是否为甲方
          var tenderCorpFlag = this.multipleSelection[0].tenderCorpFlag;
          // 招标组织形式
          var tenderMethod = this.multipleSelection[0].tenderMethod;
          // 如果招标组织形式不是 自行组织
          if (tenderMethod && tenderMethod !== "1") {
            // 则验证若是招标人则不能修改操作
            if (tenderCorpFlag === "01") {
              this.$alert("该项目为委托招标请直接点击项目进入详情进行操作，不能修改项目数据。", "warning");
              return;
            }
          }
          // 状态名称
          var stateName = "";
          // 检查状态
          var checkFlg = true;
          // 提交的场合
          if (state == 'tj') {
            // 状态名称
            stateName = "提交";
            // 存在甲方确认信息的场合
            if (tenderSignedId) {
              // 盖章信息为空的场合
              if (tenderSignedState == 'tj') {
                // 状态名称
                stateName = '招标人确认中';
                // 检查状态
                checkFlg = false;
              } else if (tenderSignedState == 'tg' || tenderSignedState == 'bc') {
                // 状态名称
                stateName = '提交';
                // 检查状态
                checkFlg = false;
              }
            } else {
              checkFlg = false;
            }
          } else if (state == 'tg') {
            // 状态名称
            stateName = "通过";
            // 检查状态
            checkFlg = false;
          }
          // 验证失败的场合
          if (!checkFlg) {
            this.$alert('该项目当前状态为“' + stateName + '”，不能修改！', 'warning');
            return;
          }
          // 状态等于提交
          if (state === "tj") {
            this.$alert('该项目当前状态为“提交”，不能修改！', 'warning');
            return;
          }
          // 获取选择的数据
          var dataObj = this.multipleSelection[0];
          // 跳转详情页面
          this.$router.push({
            path: "/calibrationInvalidDetail",
            query: {
              controllerFlag: "update",
              publicityNumber: this.multipleSelection[0].publicityNumber,
              id: this.multipleSelection[0].basicInfoId,
              flag: flag,
              tenderSignedId: dataObj.tenderSignedId,
              tenderSignedState: dataObj.tenderSignedState,
              state: dataObj.state,
            }
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请至少选中一行数据！", "warning");
        return;
      }
    },

    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 查看详情
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 请求参数
      let obj = {
        controllerFlag: "detail",
        id: e.val.basicInfoId,
        publicityNumber: e.val.publicityNumber
      }
      // 签章状态不为空
      if (e.val.tenderSignedState) {
        // 请求参数
        obj = {
          controllerFlag: "detail",
          isTenderSignature: "1",
          id: e.val.basicInfoId,
          publicityNumber: e.val.publicityNumber
        }
      }
      obj = { 
        ...obj,
        tenderSignedId: e.val.tenderSignedId,
        tenderSignedState: e.val.tenderSignedState,
        state: e.val.state,
      }
      // 跳转详情页面
      this.$router.push({
        path: "/calibrationInvalidDetail",
        query: obj,
      });
    },
  }
};
